import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M8 14.25C8 13.85 8 10.9167 8 9.75L6.5 10.25" />
		<Path d="M11 12H13" />
		<Path d="M17.5 13.5H15.5C15.5 11.4333 17.5 11.95 17.5 10.4C17.5 9.62503 16.5 8.975 15.5 9.74999" strokeLinecap="square" />
	</SVG>
);
